import {Line} from "react-konva";
import type Konva from "konva";
import type {DungeonLevel} from "@/dungeons/model/DungeonLevel.ts";
import type {LevelTransition} from "@/dungeons/model/DungeonGeometry.ts";
import {gridToWorld} from "@/dungeons/geometry/Coordinates.ts";

export default function DungeonTransitionLayer({level, scale, canSelect, onSelect, onHover}: {
    level: DungeonLevel;
    scale: number;
    canSelect: boolean;
    onSelect: (transition: LevelTransition) => void;
    onHover: (transition?: LevelTransition) => void;
}) {
    const select = (event: Konva.KonvaEventObject<MouseEvent | TouchEvent>, transition: LevelTransition) => {
        if (!canSelect) return;
        event.cancelBubble = true;
        onSelect(transition);
    };

    return <>{level.geometry.transitions.map(transition => {
        const linked = Boolean(transition.targetLevelId);
        const points = transition.points.flatMap(point => {
            const world = gridToWorld(point, level.geometry.grid);
            return [world.x, world.y];
        });
        return <Line key={transition.id} points={points} closed
            fill={linked ? "rgba(56, 189, 248, 0.10)" : "rgba(148, 163, 184, 0.08)"}
            stroke={linked ? "#38bdf8" : "#94a3b8"}
            strokeWidth={2 / scale} dash={[8 / scale, 5 / scale]}
            onClick={event => select(event, transition)}
            onTap={event => select(event, transition)}
            onMouseEnter={event => {
                onHover(transition);
                if (canSelect) event.target.getStage()?.container().style.setProperty("cursor", "pointer");
            }}
            onMouseLeave={event => {
                onHover();
                event.target.getStage()?.container().style.removeProperty("cursor");
            }}/>;
    })}</>;
}
